export enum DownloadTypeEnum {
    Word = 1,
    Excel = 2,
    PDF = 3
}
